import { onSubmitSellerGdm } from 'utils';
import { SellerGdmRegisterOnSubmitFunction } from './createSellerGdm.type';

const adminCreateOnSubmit: SellerGdmRegisterOnSubmitFunction = payload => {
  return onSubmitSellerGdm({ method: 'post', ...payload });
};

export default adminCreateOnSubmit;
